document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 100) {
      header.classList.add("header-scrolled");
    } else {
      header.classList.remove("header-scrolled");
    }
  });
});





